<template>
    <modal :modal-id="modalId"
        :title="modalTitle"
        :preloader="preloader"
        @submit="submit"
        @close-modal="closeModal">

        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            <form class="mb-0" :class="{'loading-opacity': preloader}" ref="form" :data-url='selectedUrl ? `master/appointment-type/${inputs.id}` : `master/appointment-type`'>

                <div class="form-group row align-items-center">
                    <label for="inputs_name" class="col-sm-3 mb-0">
                        {{ $t('name') }}
                    </label>
                    <app-input id="inputs_name"
                               class="col-sm-9"
                               type="text"
                               v-model="inputs.name"
                               :placeholder="$t('name')"
                               :required="true"/>

                </div>

                <div class="form-group row align-items-center">
                    <label for="inputs_is_active" class="col-sm-3 mb-0">
                        &nbsp;
                    </label>
                    <div class="col-sm-8">
                        <app-input id="inputs_is_active" :list-value-field="$t('is_active')" type="single-checkbox" v-model="inputs.is_active" />
                    </div>
                </div>
                <div class="form-group row align-items-center">

                    <div class="col-sm-3">
                    </div>
                    <div class="col-sm-4">
                        <app-input id="inputs_is_active_booking_date" :list-value-field="'Booking Date'" type="single-checkbox" v-model="inputs.is_active_booking_date" />
                    </div>
                    <div class="col-sm-4">
                        <app-input id="inputs_is_active_booking_time" :list-value-field="'Booking Time'" type="single-checkbox" v-model="inputs.is_active_booking_time" />
                    </div>

                    <div class="col-sm-3">
                    </div>
                    <div class="col-sm-4">
                        <app-input id="inputs_is_active_status" :list-value-field="'Status'" type="single-checkbox" v-model="inputs.is_active_status" />
                    </div>
                    <div class="col-sm-4">
                        <app-input id="inputs_is_active_reason" :list-value-field="'Reason'" type="single-checkbox" v-model="inputs.is_active_reason" />
                    </div>
                    
                    <div class="col-sm-3">
                    </div>
                    <div class="col-sm-4">
                        <app-input id="inputs_is_active_assign_to" :list-value-field="'Assign To'" type="single-checkbox" v-model="inputs.is_active_assign_to" />
                    </div>
                </div>
                
            </form>
        </template>
    </modal>
</template>

<script>
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin.js";
    import {ModalMixin} from "../../../../Mixins/ModalMixin";

    export default {
        name: "ModalForm",
        mixins: [FormMixin, ModalMixin],
        props: {
            tableId: String,
            formId: String,
            value: {
                type: Object,
                default: () => {
                    return {
                        id: undefined,
                        name: '',
                        is_active: '',
                        is_active_booking_date: '',
                        is_active_booking_time: '',
                        is_active_status: '',
                        is_active_reason: '',
                        is_active_assign_to: '',
                    }
                },
            }
        },
        data() {
            return {
                preloader: false,
                inputs: {
                    name: '',
                    is_active: true, // Default ter-checklist
                    is_active_booking_date: true,
                    is_active_booking_time: true,
                    is_active_status: true,
                    is_active_reason: true,
                    is_active_assign_to: true,
                },
                // statusLists: [
                //     {id: '', value: "Choose One",},
                //     {id: 'active', value: "Active",},
                //     {id: 'inactive', value: "Inactive",},
                //     {id: 'invited', value: "Invite",},
                // ],
                // genderLists: [
                //     {id: 'male', value: "Male"},
                //     {id: 'female', value: "Female"},
                //     {id: 'other', value: "Other"},
                // ],
                modalId: this.formId,
                modalTitle: this.$t('add'),
            }
        },
        created() {
            if (this.selectedUrl) {
                this.modalTitle = this.$t('edit');
                this.preloader = true;
            }
        },
        methods: {
            submit() {
                this.save(this.inputs);
            },
            afterSuccess(response) {
                this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId);
            },

            afterSuccessFromGetEditData(response) {
                if (response.data.phone) this.phone = response.data.phone;
                this.inputs = response.data;
                this.preloader = false;
            }
        },
    }
</script>
